module.exports = __webpack_public_path__ + "img/schedule20260922_2.b145e15a.jpg";